import { createSelector } from 'reselect';
import { getPathname } from '@bridebook/web/lib/app/selectors';
import { isCollaboratorOnboardingPage, isOnboardingPage } from '@bridebook/web/lib/search/utils';
import { IApplicationState } from '@bridebook/web/lib/types';

const _getOnboardingState = (state: IApplicationState) => state.onboarding;

export const getSuppliersToContact = createSelector(
  [_getOnboardingState],
  (onboarding) => onboarding.suppliersToContact,
);

/**
 * Tells whether the current page is any of the onboarding flows, either the
 * couple or the collaborator one.
 */
export const selectIsAnyOnboardingPage = createSelector(
  [getPathname],
  (pathname) => isOnboardingPage(pathname) || isCollaboratorOnboardingPage(pathname),
);
